import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import TopicTitle from '../../../components/topicTitle';

const handleData = data => {
    const arr = [];

    for (let i = 0; i < data.length; i += 2) {
        arr.push(data.slice(i, i + 2));
    }

    return arr;
};

class PointView extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        titleAd: PropTypes.object,
    };

    sliderTmpl = item => {
        return (
            <div className={styles.point}>
                <div className={styles.info}>
                    <div className={styles.box_l}>
                        <img src={item.avatar} />
                    </div>
                    <div className={styles.box_r}>
                        <div className={styles.name}>{item.name}</div>
                        <div className={styles.role}>{item.role}</div>
                    </div>
                </div>
                <div className={styles.leftmark_box}>
                    <span className={styles.leftmark} />
                </div>
                <div className={styles.text}>
                    {item.info.url ? (
                        <a href={item.info.url} target="_blank" title={item.point}>
                            {item.point}
                        </a>
                    ) : (
                        <span> {item.point}</span>
                    )}
                </div>
                <div className={styles.rightmark_box}>
                    <span className={styles.rightmark} />
                </div>
            </div>
        );
    };

    render() {
        const { content, titleAd } = this.props;

        const data = handleData(content.data);

        return (
            <React.Fragment>
                {content.title !== '' ? (
                    <TopicTitle
                        id={content.specialId}
                        moduleIndex={content.moduleIndex}
                        title={content.title}
                        titleAd={titleAd}
                    />
                ) : (
                    ''
                )}
                <div className={styles.point_box}>
                    {data.map((item, index) => (
                        <div className={styles.point} key={index}>
                            <div className={styles.point_l}>
                                <div className={styles.info}>
                                    <div className={styles.box_l}>
                                        <img src={item[0].avatar} />
                                    </div>
                                    <div className={styles.box_r}>
                                        <div className={styles.name}>{item[0].name}</div>
                                        <div className={styles.role}>{item[0].role}</div>
                                        <div className={styles.bar} />
                                    </div>
                                </div>
                                <div className={styles.leftmark_box}>
                                    <span className={styles.leftmark} />
                                </div>
                                <div className={styles.text}>
                                    {item[0].info.url ? (
                                        <a href={item[0].info.url} target="_blank" title={item[0].point}>
                                            {item[0].point}
                                        </a>
                                    ) : (
                                        <span> {item[0].point}</span>
                                    )}
                                </div>
                                <div className={styles.rightmark_box}>
                                    <span className={styles.rightmark} />
                                </div>
                            </div>
                            {item[1] ? (
                                <div className={styles.point_r}>
                                    <div className={styles.info}>
                                        <div className={styles.box_l}>
                                            <img src={item[1].avatar} />
                                        </div>
                                        <div className={styles.box_r}>
                                            <div className={styles.name}>{item[1].name}</div>
                                            <div className={styles.role}>{item[1].role}</div>
                                            <div className={styles.bar} />
                                        </div>
                                    </div>
                                    <div className={styles.leftmark_box}>
                                        <span className={styles.leftmark} />
                                    </div>
                                    <div className={styles.text}>
                                        {item[1].info.url ? (
                                            <a href={item[1].info.url} target="_blank" title={item[0].point}>
                                                {item[1].point}
                                            </a>
                                        ) : (
                                            <span> {item[1].point}</span>
                                        )}
                                    </div>
                                    <div className={styles.rightmark_box}>
                                        <span className={styles.rightmark} />
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    ))}
                </div>
            </React.Fragment>
        );
    }
}

export default errorBoundary(PointView);
